import React, { useEffect } from "react";

import { Row, Col } from "react-bootstrap";
import FASTable from "../../../../components/Tables/FASTable";
import { useDispatch, useSelector } from "react-redux";
import { BankFasGstSalePur } from "../../../../Redux/Slice/Fas/DayBook Analysis/Bank/BankSlice";
import Cookies from "js-cookie";
import { format } from "date-fns";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";

export const Gstr = () => {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { BankFasGstSalePurdata } = useSelector((state) => state.BankSlice);
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();

  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");
  const DataBase = Cookies.get("Database");
  let YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(
      BankFasGstSalePur({
        Firm,
        Year: YearId,
      }),
    );
  }, [dispatch, YearId, Firm, DataBase]);
  const getRows = BankFasGstSalePurdata?.SaleDtl?.map((label, index) => ({
    srNumber: index + 1,
    MonthName: label.MonthName,
    TaxableAmt: label.TaxableAmt,
    SGSTAmt: label.SGSTAmt,
    CGSTAmt: label.CGSTAmt,
    IGSTAmt: label.IGSTAmt,
    Total: label.Total,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Month Name",
      key: "MonthName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Taxable Amt",
      key: "TaxableAmt",
      align: "right",
      format: "true",
    },
    {
      label: "SGST Amt",
      key: "SGSTAmt",
      align: "right",
      format: "true",
    },
    {
      label: "CGST Amt",
      key: "CGSTAmt",
      align: "right",
      format: "true",
    },
    {
      label: "IGST Amt",
      key: "IGSTAmt",
      align: "right",
      format: "true",
    },
    {
      label: "Total",
      key: "Total",
      align: "right",
      format: "true",
    },
  ];

  const getRows2 = BankFasGstSalePurdata?.PurDtl?.map((label, index) => ({
    srNumber: index + 1,
    MonthName: label.MonthName,
    TaxableAmt: label.TaxableAmt,
    SGSTAmt: label.SGSTAmt,
    CGSTAmt: label.CGSTAmt,
    IGSTAmt: label.IGSTAmt,
    Total: label.Total,
  }));

  const getColumns2 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Month Name",
      key: "MonthName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "TaxableAmt",
      key: "TaxableAmt",
      align: "right",
      format: "true",
    },
    {
      label: "SGSTAmt",
      key: "SGSTAmt",
      align: "right",
      format: "true",
    },
    {
      label: "CGSTAmt",
      key: "CGSTAmt",
      align: "right",
      format: "true",
    },
    {
      label: "IGSTAmt",
      key: "IGSTAmt",
      align: "right",
      format: "true",
    },
    { label: "Total", key: "Total", format: "true", align: "right" },
  ];

  if (BankFasGstSalePur === "no" || BankFasGstSalePurdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      <Row className="g-4">
        <Col md={12} sm={12}>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour4,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour11,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "600",
                }}
              >
                GSTR-1
              </h2>
            </div>
            <FASTable data={getRows} columns={getColumns} />
          </div>
        </Col>

        <Col md={12} sm={12}>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour4,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour11,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "600",
                }}
              >
                GSTR-2
              </h2>
            </div>
            <FASTable data={getRows2} columns={getColumns2} />
          </div>
        </Col>
      </Row>
    </div>
  );
};
